
import * as actions from './actionsTypes';
import errorManage from '../../errorManage';

import surveyResultsServices from './surveyResults.services';

export const getSurveyInfo = (surveyId) => async (dispatch) => {
  dispatch({ type: actions.FETCH_SURVEY_INFO_REQUEST, payload: true });
  try {
    const response = await surveyResultsServices.getSurveyInfo(surveyId);
    
    const surveyInfo = response.data;
    dispatch({ type: actions.FETCH_SURVEY_INFO_SUCCESS, payload: surveyInfo });
    
    return surveyInfo;
  } catch (error) {
    errorManage(error, dispatch, actions.FETCH_SURVEY_INFO_FAILURE);
    throw error; // Re-throw para manejo en el componente
  } finally {
    dispatch({ type: actions.FETCH_SURVEY_INFO_REQUEST, payload: false });
  }
}

export const getSurveyResults = (params) => async (dispatch) => {
  dispatch({ type: actions.FETCH_SURVEY_RESULTS_REQUEST, payload: true });
  try {
    if (params.survey_id) {
      await dispatch(getSurveyInfo(params.survey_id));
    }
    
    const response = await surveyResultsServices.getSurveyResults(params);

    let results = [];
    if (response.data && response.data.data && Array.isArray(response.data.data)) {
      results = response.data.data;
    } else if (Array.isArray(response.data)) {
      results = response.data;
    }
    
    dispatch({ type: actions.FETCH_SURVEY_RESULTS_SUCCESS, payload: results });
  } catch (error) {
    errorManage(error, dispatch, actions.FETCH_SURVEY_RESULTS_FAILURE);
  } finally {
    dispatch({ type: actions.FETCH_SURVEY_RESULTS_REQUEST, payload: false });
  }
}